// extracted by mini-css-extract-plugin
export default {"main":"CuestionarioYaRespondido_main__JZ0of","image":"CuestionarioYaRespondido_image__iZtC9","info":"CuestionarioYaRespondido_info__7L1KG"};